module.exports = __webpack_public_path__ + "media/14.23b1b4b4.mp3";